import React from 'react'
import PropTypes from 'prop-types'

import { Colors } from '../../utils/styles'

const ValueIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        fill={props.iconColor}
        fillRule="nonzero"
        // eslint-disable-next-line
        d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M10.2857143,16.3 L6,11.981382 L7.20857143,10.7635317 L10.2857143,13.8556622 L16.7914286,7.3 L18,8.52648752 L10.2857143,16.3 Z"
      />
    </g>
  </svg>
)

export default ValueIcon

ValueIcon.propTypes = {
  iconColor: PropTypes.string,
}

ValueIcon.defaultProps = {
  iconColor: Colors.BLACK,
}
